import FORM_FIELD from './const';

export const AdditionalFieldOptions = {
  value: '',
};

export const BaseFieldOptions = {
  key: undefined,
  label: undefined,
  name: undefined,
};

export const BaseElementOptions = {
  key: undefined,
  name: undefined,
};

export const OptionalPropertiesMap = {
  isRequired: 'props.isRequired',
  placeholder: 'props.input.placeholder',
  defaultValue: 'props.input.defaultValue',
  checklist: 'checklist',
  tooltip: 'props.tooltip',
  validations: 'validations',
  valid: 'props.valid',
  error: 'props.error',
  props: 'props',
  input: 'props.input',
  readOnly: 'props.input.readOnly',
  className: 'props.className',
};

export const ValidationOptions = {
  valid: undefined,
  error: undefined,
};

function createInputElement(options) {
  validateOptions(options, Object.keys(BaseElementOptions));
  return {
    type: FORM_FIELD.ELEMENT.INPUT,
    key: options.key,
    props: { ...options },
  };
}

function createInputField(options) {
  const BaseInputFieldOptions = { ...BaseFieldOptions, type: undefined };
  validateFieldOptions(options);
  validateOptions(options, Object.keys(BaseInputFieldOptions));
  const model = inputFieldModel({ ...BaseFieldOptions, ...AdditionalFieldOptions, ...options });

  if (model.validations) return { ...model, props: { ...ValidationOptions, ...model.props } };
  return model;
}

function createPasswordWithMeterField(options) {
  const BaseInputFieldOptions = { ...BaseFieldOptions, type: undefined };
  validateFieldOptions(options);
  validateOptions(options, Object.keys(BaseInputFieldOptions));
  const model = passwordWithMeterFieldModel({ ...BaseFieldOptions, ...AdditionalFieldOptions, ...options });

  if (model.validations) return { ...model, props: { ...ValidationOptions, ...model.props } };
  return model;
}

function createNumberWithTemplateField(options) {
  const BaseNumberWithTemplateOptions = { ...BaseFieldOptions, wildcardChars: undefined };
  validateFieldOptions(options);
  validateOptions(options, Object.keys(BaseNumberWithTemplateOptions));
  const model = numberWithTemplateModel({ ...BaseFieldOptions, ...AdditionalFieldOptions, ...options });

  if (model.validations) return { ...model, props: { ...ValidationOptions, ...model.props } };
  return model;
}

function createCheckboxField(options) {
  validateFieldOptions(options);
  validateOptions(options, Object.keys(BaseFieldOptions));
  const model = checkboxModel({ ...BaseFieldOptions, ...AdditionalFieldOptions, ...options });

  if (model.validations) return { ...model, props: { ...ValidationOptions, ...model.props } };
  return model;
}

function baseFieldModel(options) {
  const baseModel = {
    key: options.key,
    props: {
      label: options.label,
      input: {
        name: options.name,
        'data-key': options.key,
      },
    },
    value: options.value || '',
  };

  const optionalProperties = optionalPropertiesModel(options);
  const model = { ...baseModel, ...optionalProperties };
  if (optionalProperties.hasOwnProperty('props')) {
    model.props = { ...baseModel.props, ...optionalProperties.props };
    if (optionalProperties.props.hasOwnProperty('input')) {
      model.props.input = { ...baseModel.props.input, ...optionalProperties.props.input };
    }
  }
  return model;
}

function inputFieldModel(options) {
  const model = baseFieldModel(options);
  model.type = FORM_FIELD.FIELD.INPUT;
  model.props.type = options.type;
  return model;
}

function numberWithTemplateModel(options) {
  const model = baseFieldModel(options);
  model.type = FORM_FIELD.FIELD.NUMBER_WITH_TEMPLATE;
  model.props.wildcardChars = options.wildcardChars;
  return model;
}

function checkboxModel(options) {
  const model = baseFieldModel(options);
  model.type = FORM_FIELD.FIELD.CHECKBOX;
  return model;
}

function passwordWithMeterFieldModel(options) {
  const model = baseFieldModel(options);
  model.type = FORM_FIELD.FIELD.PASSWORD_WITH_METER;
  model.props.type = options.type;
  return model;
}

export function optionalPropertiesModel(options) {
  const optionsModel = {};
  for (const option in OptionalPropertiesMap) {
    if (!options.hasOwnProperty(option)) continue;
    const optionPath = OptionalPropertiesMap[option].split('.');
    let ref = optionsModel;
    for (let i = 0; i < optionPath.length; i++) {
      const curr = optionPath[i];
      if (i === optionPath.length - 1) {
        if (Object.prototype.toString.call(options[option]) === '[object Object]') {
          ref[curr] = { ...ref[curr], ...options[option] };
        } else ref[curr] = options[option];
      } else {
        ref[curr] = ref[curr] || {};
        ref = ref[curr];
      }
    }
  }
  return optionsModel;
}

function validateFieldOptions(options) {
  if (options.props && options.props.input) {
    throw new Error(`FormField Model: ${FORM_FIELD.ERROR.NESTED_INPUT}`);
  }
}

function validateOptions(options, requiredKeys) {
  requiredKeys.forEach((key) => {
    if (!options.hasOwnProperty(key)) {
      throw new Error(`FormField Model: ${FORM_FIELD.ERROR.MISSING_OPTION} ${ key }`);
    }
  });
}

export default {
  create: {
    field: {
      input: createInputField,
      numberWithTemplate: createNumberWithTemplateField,
      checkbox: createCheckboxField,
      passwordWithMeter: createPasswordWithMeterField
    },
    element: {
      input: createInputElement,
    },
  },
};
